<template>
    <figcaption
        class="caption"
        :style="{ color: person.colors['text-primary'] }"
    >
        <line-cover class="decoration" />
        <div class="summary">
            <p
                class="text"
                :style="{ color: person.colors['text-primary'] }"
                v-html="person.description"
            />
            <caption-tags
                :tags="person.tags"
                :color="person.colors['text-secondary']"
            />
        </div>
    </figcaption>
</template>

<script>
import CaptionTags from "@/components/CaptionTags";
import LineCover from "@/components/LineCover";

export default {
    components: { CaptionTags, LineCover },
    props: {
        person: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base

.caption
    --offset-decoration: calc(calc(var(--line-base) * -2) - 9%)
    --padding-caption: calc(var(--line-base) * 2)

    position: relative
    z-index: 1
    display: flex
    flex-direction: column
    gap:  calc(var(--line-base) * .75)
    box-sizing: border-box

    +media('<small')
        align-items: center

    +media('>=small')
        flex: 0 0 50%
        gap: var(--line-base)

    +media('>=large')
        padding-top: var(--padding-caption)

.decoration
    position: relative
    max-width: 25%
    margin-top: var(--line-base)
    stroke: currentColor

    +media('>=large')
        margin: 0

.summary
    +media('>=large')
        opacity: 0

    > *
        margin-top: calc(var(--line-base) * 0.25)

        +media('>=large')
            margin: 0

+media('>=large')
    .member
        &:nth-child(odd)
            .caption
                padding-left: var(--padding-caption)
            .summary
                transform: translateX(-15.5%)
            .decoration
                left: var(--offset-decoration)
                transform: translateX(104%)

        &:nth-child(even)
            .caption
                padding-right: var(--padding-caption)
            .summary
                transform: translateX(15.5%)
            .decoration
                align-self: flex-end
                right: var(--offset-decoration)
                transform: translateX(-104%)
</style>
